import React from 'react'

import { ReportingPanelQueryParams } from './reportingPanelUtils'
import SpendStackedBarPanel from './SpendStackedBarPanel'

const SpendByVendorPanel: React.FC<ReportingPanelQueryParams> = (props) => (
  <SpendStackedBarPanel
    {...props}
    chartId="spend_by_vendor"
    title="Spend by merchant"
    description="Spend grouped by merchant."
    summaryLabel="Top merchant"
  />
)

export default SpendByVendorPanel
